import React, { useState } from 'react';

import { ISectionWithCollapsiblesFields } from '../../../types/contentful';

import { Box } from '../Box';
import { BlockContainer, Layout, Column } from '../Layout';
import { Collapsible } from '../Collapsible';
import RichText from '../RichText';

import { MaxWidthHeading, FullWidthHeading } from './styles';

interface Props extends ISectionWithCollapsiblesFields {
  fullWidthHeader?: boolean;
}

export function SectionWithCollapsibles({
  headingText,
  collapsibles,
  footerContent,
  fullWidthHeader
}: Props) {
  const startingCollapsibles = collapsibles
    ? collapsibles.map(() => 'close')
    : [];
  const [openCollapsibles, setOpenCollapsibles] =
    useState(startingCollapsibles);

  const toggleCollapsible = (index: number) => {
    const newCollapsibles = openCollapsibles.map((collapsible, i) => {
      if (index === i) {
        if (collapsible === 'open') return 'close';
        else return 'open';
      } else {
        return collapsible;
      }
    });
    setOpenCollapsibles(newCollapsibles);
  };

  return (
    <BlockContainer
      marginTop={{
        0: 'xs',
        tablet: 'blockMarginY_tablet',
        desktop: 'blockMarginY'
      }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-blockid="sectionWithCollapsibles"
      data-testid="section-with-collapsibles"
    >
      <Layout>
        <Column size={{ 0: 10, tablet: 12, desktop: 8 }} flexDirection="column">
          {headingText && !fullWidthHeader && (
            <Box paddingBottom="l">
              <MaxWidthHeading
                as="h2"
                fontSize={{ 0: 'h2_0', tablet: 'h2_desktop' }}
                fontWeight="h2"
              >
                {headingText}
              </MaxWidthHeading>
            </Box>
          )}
          {headingText && fullWidthHeader && (
            <Box paddingBottom="l">
              <FullWidthHeading
                as="h2"
                fontSize={{ 0: 'h2_0', tablet: 'h2_desktop' }}
                fontWeight="h2"
              >
                {headingText}
              </FullWidthHeading>
            </Box>
          )}
          <div>
            {collapsibles &&
              collapsibles.map(({ sys, fields }, idx: number) => {
                return (
                  fields && (
                    <Collapsible
                      {...fields}
                      key={sys?.id}
                      isOpen={openCollapsibles[idx] === 'open'}
                      onClick={() => toggleCollapsible(idx)}
                    />
                  )
                );
              })}
          </div>
          {footerContent && (
            <Box paddingTop={{ 0: 'collapsibleVert', tablet: 'l' }}>
              <RichText data={footerContent} />
            </Box>
          )}
        </Column>
      </Layout>
    </BlockContainer>
  );
}
